// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lego-builder {
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.lego-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.lego-input label {
  font-size: 1.2rem;
  color: #333;
}

.lego-input input {
  padding: 1rem;
  font-size: 1.5rem;
  border: 3px solid #333;
  border-radius: 8px;
  text-transform: uppercase;
}

.input-help {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

.lego-preview {
  background-color: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin: 2rem;
  max-width: 100%;
  overflow-x: auto;
}

.lego-bricks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

.lego-brick {
  width: 60px;
  height: 80px;
  position: relative;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);
}

.brick-letter {
  color: white;
  font-size: 2rem;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.brick-studs {
  position: absolute;
  top: -8px;
  display: flex;
  gap: 8px;
}

.brick-stud {
  width: 16px;
  height: 8px;
  background-color: inherit;
  border-radius: 8px 8px 0 0;
}

@media (max-width: 768px) {
  .lego-builder {
    gap: 1.25rem;
  }

  .lego-controls {
    gap: 1.25rem;
  }

  .lego-input label {
    font-size: 1rem;
  }

  .lego-input input {
    padding: 0.85rem 1rem;
    font-size: 1.15rem;
    width: 100%;
    min-height: 3rem;
  }

  .input-help {
    font-size: 0.8rem;
  }

  .size-selectors-row {
    flex-direction: column;
    align-items: stretch;
    gap: 1.25rem;
  }

  .size-selector--end {
    align-items: stretch;
  }

  .size-selector label {
    font-size: 1rem;
  }

  .size-buttons {
    gap: 0.5rem;
    width: 100%;
  }

  .size-button {
    flex: 1;
    min-height: 2.75rem;
    padding: 0.6rem 0.5rem;
    font-size: 1rem;
    touch-action: manipulation;
  }

  .design-3d-link {
    padding: 0.85rem 1rem;
    gap: 0.75rem;
  }

  .design-3d-link__icon {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 0.9rem;
  }

  .design-3d-link__text {
    font-size: 1rem;
    line-height: 1.3;
  }

  .lego-preview {
    margin: 0;
    padding: 0.75rem;
    border-radius: 10px;
  }

  .lego-baseplate-container {
    padding: 0.25rem 0;
    margin-bottom: 1.25rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .lego-baseplate-surface {
    margin-left: auto;
    margin-right: auto;
  }

  .brick-inventory {
    margin-top: 1.5rem;
    padding: 1rem;
  }

  .brick-inventory h3 {
    font-size: 1.15rem;
    margin-bottom: 0.75rem;
  }

  .inventory-item {
    gap: 0.75rem;
    padding: 0.65rem 0;
    font-size: 0.95rem;
  }

  .affiliate-build-content {
    padding-top: 1rem;
  }

  .affiliate-build-content h4 {
    font-size: 1rem;
    margin-bottom: 0.85rem;
  }

  .affiliate-button {
    padding: 0.85rem 1rem;
    font-size: 0.95rem;
  }

  .piece-count {
    min-width: 2.5rem;
  }

  .lego-brick {
    width: 40px;
    height: 60px;
  }

  .brick-letter {
    font-size: 1.5rem;
  }

  .brick-studs {
    top: -6px;
    gap: 6px;
  }

  .brick-stud {
    width: 12px;
    height: 6px;
  }
}

@media (max-width: 380px) {
  .design-3d-link__text {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
  }

  .lego-preview {
    padding: 0.5rem;
  }
}

.lego-letters {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
  transform-style: preserve-3d;
  padding: 20px;
}

.lego-baseplate-surface {
  position: relative;
  margin: 0 auto 10px;
  flex-shrink: 0;
}

.lego-baseplate-grid {
  display: grid;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  border-radius: 4px;
  overflow: hidden;
  box-shadow:
    inset 0 2px 5px rgba(0, 0, 0, 0.1),
    0 2px 5px rgba(0, 0, 0, 0.1);
}

.grid-cell {
  position: relative;
  background-color: var(--baseplate-color);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.grid-cell .base-stud {
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(var(--stud-px, 10px) * 0.45);
  height: calc(var(--stud-px, 10px) * 0.45);
  border-radius: 50%;
  background-color: #d0d0d0;
  transform: translate(-50%, -50%);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
}

.lego-brick-top {
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  padding: 1px;
  border-radius: 3px;
  box-shadow:
    inset -1px -1px 2px rgba(0, 0, 0, 0.25),
    inset 1px 1px 2px rgba(255, 255, 255, 0.25),
    0 2px 4px rgba(0, 0, 0, 0.15);
  transform-style: preserve-3d;
  transform: translateZ(4px);
  transition: transform 0.2s;
}

.lego-brick-top:hover {
  transform: translateZ(8px);
}

.brick-studs-grid {
  display: grid;
  width: 100%;
  height: 100%;
  gap: 1px;
}

.lego-brick-top .brick-stud {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: inherit;
  filter: brightness(1.08);
  box-shadow:
    inset -1px -1px 2px rgba(0, 0, 0, 0.35),
    inset 1px 1px 2px rgba(255, 255, 255, 0.4),
    0 1px 1px rgba(0, 0, 0, 0.15);
}

.lego-pixel {
  position: absolute;
  border-radius: 2px;
  box-shadow:
    inset -2px -2px 4px rgba(0, 0, 0, 0.2),
    inset 2px 2px 4px rgba(255, 255, 255, 0.2);
  transition: transform 0.2s;
}

.lego-pixel:hover {
  transform: translateY(-2px);
}

.stud {
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  height: 6px;
  background-color: inherit;
  border-radius: 6px 6px 2px 2px;
  box-shadow: inset -1px -1px 2px rgba(0, 0, 0, 0.2);
}

.brick-inventory {
  margin-top: 80px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.brick-inventory h3 {
  margin: 0 0 20px;
  color: #333;
  font-size: 1.4rem;
}

.brick-inventory ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.brick-inventory li {
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.brick-inventory li:last-child {
  border-bottom: 0;
}

.lego-controls {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.design-3d-link {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  text-decoration: none;
  color: #333;
  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);
  border: 2px solid #333;
  border-radius: 10px;
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.12);
  transition:
    transform 0.15s,
    box-shadow 0.15s;
}

.design-3d-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.15);
}

.design-3d-link:active {
  transform: translateY(1px);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.12);
}

.design-3d-link__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: -0.02em;
  color: #333;
  background: var(--lego-yellow);
  border-radius: 8px;
  box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.12);
}

.design-3d-link__text {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.15rem;
  font-weight: bold;
}

.design-3d-link__badge {
  padding: 0.15rem 0.5rem;
  font-size: 0.7rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: var(--lego-blue);
  color: #fff;
  border-radius: 999px;
}

.size-selectors-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
}

.size-selector {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.size-selector--end {
  align-items: flex-end;
}

.size-selector label {
  font-size: 1.2rem;
  color: #333;
}

.size-buttons {
  display: flex;
  gap: 1rem;
}

.size-button {
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  border: 2px solid #333;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
}

.size-button:hover {
  background: #f0f0f0;
}

.size-button.active {
  background: var(--lego-yellow);
  border-color: var(--lego-yellow);
}

.inventory-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.piece-count {
  font-weight: bold;
  color: var(--lego-blue);
  min-width: 3rem;
}

.piece-description {
  color: #333;
}

.affiliate-build-box {
  margin-top: 1.5rem;
}

.affiliate-build-divider {
  height: 1px;
  background: #e7e7e7;
}

.affiliate-build-content {
  padding-top: 1.25rem;
}

.affiliate-build-content h4 {
  margin: 0 0 1rem;
  font-size: 1.1rem;
  color: #333;
}

.affiliate-build-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.affiliate-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.95rem 1.1rem;
  border-radius: 10px;
  text-decoration: none;
  font-weight: bold;
  text-align: center;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    background-color 0.15s ease;
}

.affiliate-button:hover {
  transform: translateY(-1px);
}

.affiliate-button--primary {
  color: #1f1f1f;
  background: linear-gradient(135deg, #ffd24d 0%, #ffbf1f 100%);
  border: 2px solid #f0b400;
  box-shadow: 0 3px 0 rgba(161, 120, 0, 0.18);
}

.affiliate-button--primary:hover {
  box-shadow: 0 4px 0 rgba(161, 120, 0, 0.2);
}

.affiliate-button--secondary {
  color: #333;
  background: #f7f7f7;
  border: 1px solid #dcdcdc;
}

.affiliate-button--secondary:hover {
  background: #f1f1f1;
}

.lego-baseplate-container {
  padding: 20px;
  margin-bottom: 40px;
  border-radius: 8px;
  overflow-x: auto;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/LegoBuilder/LegoBuilder.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,OAAO;IACP,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB;;gCAE8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB;;;iCAG+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB;;;iCAG+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB;;8CAE4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,0DAA0D;EAC1D,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;EACvC;;oBAEkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB;;;+BAG6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".lego-builder {\n  width: 100%;\n  max-width: 800px;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.lego-input {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.lego-input label {\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.lego-input input {\n  padding: 1rem;\n  font-size: 1.5rem;\n  border: 3px solid #333;\n  border-radius: 8px;\n  text-transform: uppercase;\n}\n\n.input-help {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.lego-preview {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin: 2rem;\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.lego-bricks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.lego-brick {\n  width: 60px;\n  height: 80px;\n  position: relative;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);\n}\n\n.brick-letter {\n  color: white;\n  font-size: 2rem;\n  font-weight: bold;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.brick-studs {\n  position: absolute;\n  top: -8px;\n  display: flex;\n  gap: 8px;\n}\n\n.brick-stud {\n  width: 16px;\n  height: 8px;\n  background-color: inherit;\n  border-radius: 8px 8px 0 0;\n}\n\n@media (max-width: 768px) {\n  .lego-builder {\n    gap: 1.25rem;\n  }\n\n  .lego-controls {\n    gap: 1.25rem;\n  }\n\n  .lego-input label {\n    font-size: 1rem;\n  }\n\n  .lego-input input {\n    padding: 0.85rem 1rem;\n    font-size: 1.15rem;\n    width: 100%;\n    min-height: 3rem;\n  }\n\n  .input-help {\n    font-size: 0.8rem;\n  }\n\n  .size-selectors-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1.25rem;\n  }\n\n  .size-selector--end {\n    align-items: stretch;\n  }\n\n  .size-selector label {\n    font-size: 1rem;\n  }\n\n  .size-buttons {\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  .size-button {\n    flex: 1;\n    min-height: 2.75rem;\n    padding: 0.6rem 0.5rem;\n    font-size: 1rem;\n    touch-action: manipulation;\n  }\n\n  .design-3d-link {\n    padding: 0.85rem 1rem;\n    gap: 0.75rem;\n  }\n\n  .design-3d-link__icon {\n    width: 2.5rem;\n    height: 2.5rem;\n    font-size: 0.9rem;\n  }\n\n  .design-3d-link__text {\n    font-size: 1rem;\n    line-height: 1.3;\n  }\n\n  .lego-preview {\n    margin: 0;\n    padding: 0.75rem;\n    border-radius: 10px;\n  }\n\n  .lego-baseplate-container {\n    padding: 0.25rem 0;\n    margin-bottom: 1.25rem;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n  }\n\n  .lego-baseplate-surface {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .brick-inventory {\n    margin-top: 1.5rem;\n    padding: 1rem;\n  }\n\n  .brick-inventory h3 {\n    font-size: 1.15rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .inventory-item {\n    gap: 0.75rem;\n    padding: 0.65rem 0;\n    font-size: 0.95rem;\n  }\n\n  .affiliate-build-content {\n    padding-top: 1rem;\n  }\n\n  .affiliate-build-content h4 {\n    font-size: 1rem;\n    margin-bottom: 0.85rem;\n  }\n\n  .affiliate-button {\n    padding: 0.85rem 1rem;\n    font-size: 0.95rem;\n  }\n\n  .piece-count {\n    min-width: 2.5rem;\n  }\n\n  .lego-brick {\n    width: 40px;\n    height: 60px;\n  }\n\n  .brick-letter {\n    font-size: 1.5rem;\n  }\n\n  .brick-studs {\n    top: -6px;\n    gap: 6px;\n  }\n\n  .brick-stud {\n    width: 12px;\n    height: 6px;\n  }\n}\n\n@media (max-width: 380px) {\n  .design-3d-link__text {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n  }\n\n  .lego-preview {\n    padding: 0.5rem;\n  }\n}\n\n.lego-letters {\n  display: flex;\n  gap: 30px;\n  flex-wrap: wrap;\n  justify-content: center;\n  transform-style: preserve-3d;\n  padding: 20px;\n}\n\n.lego-baseplate-surface {\n  position: relative;\n  margin: 0 auto 10px;\n  flex-shrink: 0;\n}\n\n.lego-baseplate-grid {\n  display: grid;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow:\n    inset 0 2px 5px rgba(0, 0, 0, 0.1),\n    0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.grid-cell {\n  position: relative;\n  background-color: var(--baseplate-color);\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.grid-cell .base-stud {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: calc(var(--stud-px, 10px) * 0.45);\n  height: calc(var(--stud-px, 10px) * 0.45);\n  border-radius: 50%;\n  background-color: #d0d0d0;\n  transform: translate(-50%, -50%);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.lego-brick-top {\n  position: absolute;\n  z-index: 1;\n  box-sizing: border-box;\n  padding: 1px;\n  border-radius: 3px;\n  box-shadow:\n    inset -1px -1px 2px rgba(0, 0, 0, 0.25),\n    inset 1px 1px 2px rgba(255, 255, 255, 0.25),\n    0 2px 4px rgba(0, 0, 0, 0.15);\n  transform-style: preserve-3d;\n  transform: translateZ(4px);\n  transition: transform 0.2s;\n}\n\n.lego-brick-top:hover {\n  transform: translateZ(8px);\n}\n\n.brick-studs-grid {\n  display: grid;\n  width: 100%;\n  height: 100%;\n  gap: 1px;\n}\n\n.lego-brick-top .brick-stud {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: inherit;\n  filter: brightness(1.08);\n  box-shadow:\n    inset -1px -1px 2px rgba(0, 0, 0, 0.35),\n    inset 1px 1px 2px rgba(255, 255, 255, 0.4),\n    0 1px 1px rgba(0, 0, 0, 0.15);\n}\n\n.lego-pixel {\n  position: absolute;\n  border-radius: 2px;\n  box-shadow:\n    inset -2px -2px 4px rgba(0, 0, 0, 0.2),\n    inset 2px 2px 4px rgba(255, 255, 255, 0.2);\n  transition: transform 0.2s;\n}\n\n.lego-pixel:hover {\n  transform: translateY(-2px);\n}\n\n.stud {\n  position: absolute;\n  top: -4px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 12px;\n  height: 6px;\n  background-color: inherit;\n  border-radius: 6px 6px 2px 2px;\n  box-shadow: inset -1px -1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.brick-inventory {\n  margin-top: 80px;\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.brick-inventory h3 {\n  margin: 0 0 20px;\n  color: #333;\n  font-size: 1.4rem;\n}\n\n.brick-inventory ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.brick-inventory li {\n  padding: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n.brick-inventory li:last-child {\n  border-bottom: 0;\n}\n\n.lego-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.design-3d-link {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  text-decoration: none;\n  color: #333;\n  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);\n  border: 2px solid #333;\n  border-radius: 10px;\n  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.12);\n  transition:\n    transform 0.15s,\n    box-shadow 0.15s;\n}\n\n.design-3d-link:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.15);\n}\n\n.design-3d-link:active {\n  transform: translateY(1px);\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.12);\n}\n\n.design-3d-link__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 3rem;\n  height: 3rem;\n  font-size: 1rem;\n  font-weight: bold;\n  letter-spacing: -0.02em;\n  color: #333;\n  background: var(--lego-yellow);\n  border-radius: 8px;\n  box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.12);\n}\n\n.design-3d-link__text {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.15rem;\n  font-weight: bold;\n}\n\n.design-3d-link__badge {\n  padding: 0.15rem 0.5rem;\n  font-size: 0.7rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: var(--lego-blue);\n  color: #fff;\n  border-radius: 999px;\n}\n\n.size-selectors-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 1rem;\n}\n\n.size-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.size-selector--end {\n  align-items: flex-end;\n}\n\n.size-selector label {\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.size-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.size-button {\n  padding: 0.5rem 1rem;\n  font-size: 1.2rem;\n  border: 2px solid #333;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.size-button:hover {\n  background: #f0f0f0;\n}\n\n.size-button.active {\n  background: var(--lego-yellow);\n  border-color: var(--lego-yellow);\n}\n\n.inventory-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n.piece-count {\n  font-weight: bold;\n  color: var(--lego-blue);\n  min-width: 3rem;\n}\n\n.piece-description {\n  color: #333;\n}\n\n.affiliate-build-box {\n  margin-top: 1.5rem;\n}\n\n.affiliate-build-divider {\n  height: 1px;\n  background: #e7e7e7;\n}\n\n.affiliate-build-content {\n  padding-top: 1.25rem;\n}\n\n.affiliate-build-content h4 {\n  margin: 0 0 1rem;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.affiliate-build-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.affiliate-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 0.95rem 1.1rem;\n  border-radius: 10px;\n  text-decoration: none;\n  font-weight: bold;\n  text-align: center;\n  transition:\n    transform 0.15s ease,\n    box-shadow 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.affiliate-button:hover {\n  transform: translateY(-1px);\n}\n\n.affiliate-button--primary {\n  color: #1f1f1f;\n  background: linear-gradient(135deg, #ffd24d 0%, #ffbf1f 100%);\n  border: 2px solid #f0b400;\n  box-shadow: 0 3px 0 rgba(161, 120, 0, 0.18);\n}\n\n.affiliate-button--primary:hover {\n  box-shadow: 0 4px 0 rgba(161, 120, 0, 0.2);\n}\n\n.affiliate-button--secondary {\n  color: #333;\n  background: #f7f7f7;\n  border: 1px solid #dcdcdc;\n}\n\n.affiliate-button--secondary:hover {\n  background: #f1f1f1;\n}\n\n.lego-baseplate-container {\n  padding: 20px;\n  margin-bottom: 40px;\n  border-radius: 8px;\n  overflow-x: auto;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
